import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../service/translate/translate.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(key: any): any {
    let keyUC : string = key as string;
    keyUC = keyUC.toString().trim().toUpperCase();
    return this.translate.data[keyUC] || key;
  }
}